module.exports = __webpack_public_path__ + "img/media_reg_4.7fe03a51.png";